import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'numberRound', standalone: true })
export class NumberRoundPipe implements PipeTransform {
  transform(value: number | string | null | undefined, maxDecimals: number = 2): string {
    if (value === null || value === undefined) {
      return '';
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;

    if (Number.isNaN(numValue)) {
      return value.toString();
    }

    // Round to maxDecimals places
    const rounded = Math.round(numValue * 10 ** maxDecimals) / 10 ** maxDecimals;

    // Convert to string and remove trailing zeros after decimal point
    const roundedString = rounded.toString();

    // If it's a whole number, return without decimal
    if (rounded === Math.floor(rounded)) {
      return Math.floor(rounded).toString();
    }

    // Remove trailing zeros after decimal point
    return roundedString.replace(/\.?0+$/, '');
  }
}
